var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"JammedBookingApp--Calendar"}},[_c('datepicker',{attrs:{"inline":true,"disabled-dates":_vm.disabledDays,"calendar-class":"JammedBookingApp--CalendarInner","full-month-name":true,"maximum-view":"month","first-day-of-week":"mon"},on:{"selected":_vm.dateSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }